import request from '@/utils/request'

// 查询列表
export function findOrderServiceNodes(params) {
  return request({
    url: `/order_service_nodes`,
    method: 'get',
    params: params
  })
}

export function findOrderServiceNodeOptions(params) {
    return request({
        url: `/order_service_nodes/options`,
        method: 'get',
        params: params
    })
}

// 更新
export function updateOrderServiceNode(id, data) {
  return request({
    url: `/order_service_nodes/${id}`,
    method: 'put',
    data
  })
}

// 创建
export function createOrderServiceNode(data) {
  return request({
    url: `/order_service_nodes`,
    method: 'post',
    data
  })
}

// 删除
export function deleteOrderServiceNode(id) {
  return request({
    url: `/order_service_nodes/${id}`,
    method: 'delete'
  })
}

// 更新有效性
export function updateOrderServiceNodeEffective(id, data) {
  return request({
    url: `/order_service_nodes/${id}/effective`,
    method: 'patch',
    data
  })
}
